import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "admin-panel" }
const _hoisted_2 = { class: "admin-wrapper" }
const _hoisted_3 = { class: "admin-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Edit Hotspots", -1)
const _hoisted_5 = { class: "admin-logout" }
const _hoisted_6 = { class: "admin-toggle" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "toggleLabel",
  for: "toggleButton"
}, null, -1)
const _hoisted_8 = { class: "admin-body" }
const _hoisted_9 = { class: "form-wrapper" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group-col" }
const _hoisted_12 = ["value", "textContent"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "rooms" }, "Room", -1)
const _hoisted_14 = { class: "form-group-col" }
const _hoisted_15 = ["checked"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "player1" }, "Player 1", -1)
const _hoisted_17 = ["checked"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "player2" }, "Player 2", -1)
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "form-group-col" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "New Hotspot", -1)
const _hoisted_22 = ["value", "textContent"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "hotspots" }, "Hotspots", -1)
const _hoisted_24 = { class: "form-group separater" }
const _hoisted_25 = { class: "form-group-col" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "hsName" }, "Hotspot name", -1)
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "form-group-col" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "hsWidth" }, "Width", -1)
const _hoisted_30 = { class: "form-group-col" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "hsHeight" }, "Height", -1)
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = { class: "form-group-col" }
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<option value=\"phone\">Phone</option><option value=\"image\">Image</option><option value=\"carousel\">Carousel</option><option value=\"audio\">Audio</option><option value=\"browser\">Browser</option><option value=\"component\">Component</option>", 6)
const _hoisted_40 = [
  _hoisted_34
]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "hsType" }, "Type", -1)
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = { class: "form-group-col" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "hsComp" }, "Link", -1)
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = { class: "form-group-col" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { for: "hsYaw" }, "Yaw", -1)
const _hoisted_48 = { class: "form-group-col" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { for: "hsPitch" }, "Pitch", -1)
const _hoisted_50 = { class: "admin-footer" }
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = { class: "form-group-col" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
          }, "logout")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("input", {
            class: "toggleButton",
            id: "toggleButton",
            type: "checkbox",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adminState = !_ctx.adminState))
          }, null, 32),
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("select", {
                id: "rooms",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePano($event))),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.roomId) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (room) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: room.room,
                    value: room.room,
                    textContent: _toDisplayString(room.name)
                  }, null, 8, _hoisted_12))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.roomId]
              ]),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                id: "player1",
                type: "radio",
                name: "player",
                value: "0",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.playerId) = $event)),
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.chgPlayer && _ctx.chgPlayer(...args))),
                checked: _ctx.playerId === 0
              }, null, 8, _hoisted_15), [
                [_vModelRadio, _ctx.playerId]
              ]),
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                id: "player2",
                type: "radio",
                name: "player",
                value: "1",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.playerId) = $event)),
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.chgPlayer && _ctx.chgPlayer(...args))),
                checked: _ctx.playerId === 1
              }, null, 8, _hoisted_17), [
                [_vModelRadio, _ctx.playerId]
              ]),
              _hoisted_18
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("select", {
                id: "hotspots",
                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectHotspot($event))),
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.hotspotId) = $event))
              }, [
                _hoisted_21,
                (_ctx.hotspotList.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.hotspotList, (hotspot, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: hotspot.id,
                        textContent: _toDisplayString(hotspot.name)
                      }, null, 8, _hoisted_22))
                    }), 128))
                  : _createCommentVNode("", true)
              ], 544), [
                [_vModelSelect, _ctx.hotspotId]
              ]),
              _hoisted_23
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                id: "hsName",
                name: "name",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.hotspot.name) = $event)),
                type: "text",
                placeholder: " "
              }, null, 512), [
                [_vModelText, _ctx.hotspot.name]
              ]),
              _hoisted_26
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _withDirectives(_createElementVNode("input", {
                id: "hsWidth",
                name: "width",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.hotspot.width) = $event)),
                type: "number",
                placeholder: " "
              }, null, 512), [
                [_vModelText, _ctx.hotspot.width]
              ]),
              _hoisted_29
            ]),
            _createElementVNode("div", _hoisted_30, [
              _withDirectives(_createElementVNode("input", {
                id: "hsHeight",
                name: "heigth",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.hotspot.height) = $event)),
                type: "number",
                placeholder: " "
              }, null, 512), [
                [_vModelText, _ctx.hotspot.height]
              ]),
              _hoisted_31
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _withDirectives(_createElementVNode("select", {
                id: "hsType",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.hotspot.type) = $event))
              }, _hoisted_40, 512), [
                [_vModelSelect, _ctx.hotspot.type]
              ]),
              _hoisted_41
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _withDirectives(_createElementVNode("input", {
                id: "hsComp",
                name: "path",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.hotspot.path) = $event)),
                type: "text",
                placeholder: " "
              }, null, 512), [
                [_vModelText, _ctx.hotspot.path]
              ]),
              _hoisted_44
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _withDirectives(_createElementVNode("input", {
                id: "hsYaw",
                name: "yaw",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.hotspot.yaw) = $event)),
                type: "number",
                placeholder: " "
              }, null, 512), [
                [_vModelText, _ctx.hotspot.yaw]
              ]),
              _hoisted_47
            ]),
            _createElementVNode("div", _hoisted_48, [
              _withDirectives(_createElementVNode("input", {
                id: "hsPitch",
                name: "pitch",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.hotspot.pitch) = $event)),
                type: "number",
                placeholder: " "
              }, null, 512), [
                [_vModelText, _ctx.hotspot.pitch]
              ]),
              _hoisted_49
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("button", {
                class: "editButton",
                type: "button",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.placeHotspot && _ctx.placeHotspot(...args))),
                disabled: (_ctx.hotspotId !== '')
              }, "Place", 8, _hoisted_53),
              _createElementVNode("button", {
                class: "editButton",
                type: "button",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.saveHotspot(_ctx.hotspotId))),
                disabled: (_ctx.hotspot.name === '')
              }, [
                ((_ctx.hotspotId === ''))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_55, "Save"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_56, "Update"))
              ], 8, _hoisted_54),
              _createElementVNode("button", {
                class: "editButton",
                type: "button",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.deleteHotspot(_ctx.hotspotId))),
                disabled: (_ctx.hotspotId === '')
              }, "Delete", 8, _hoisted_57)
            ])
          ])
        ])
      ])
    ])
  ]))
}